import { render, staticRenderFns } from "./widget-preview.vue?vue&type=template&id=387abf87&scoped=true&"
import script from "./widget-preview.vue?vue&type=script&lang=js&"
export * from "./widget-preview.vue?vue&type=script&lang=js&"
import style0 from "./widget-preview.vue?vue&type=style&index=0&id=387abf87&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387abf87",
  null
  
)

export default component.exports